// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmCancelTender_description__3tYEQ"};